import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { Header } from "../ui/header";
import { Footer } from "../ui/footer";
import "../../css/header.css";
import "../../css/footer.css";
import blogBanner from "../../image/blogimg.jpg";
import "../../css/blogdetails.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import { Link } from "react-router-dom";
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";

const BASE_URL = "https://admin.bookvenue.app/api";

const BlogDetails = () => {
  const { slug } = useParams();
  const [blog, setBlog] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchBlog = async () => {
      try {
        const res = await axios.get(`${BASE_URL}/get-blog-by-slug/${slug}`);
        setBlog(res.data.blogs || null);
      } catch (error) {
        console.error("Error fetching blog:", error);
        setBlog(null);
      } finally {
        setLoading(false);
      }
    };

    fetchBlog();
  }, [slug]);

  if (loading) return <div className="text-center my-5">Loading...</div>;

  if (!blog)
    return <div className="text-center my-5 text-danger">Blog not found.</div>;

  return (
    <>
      <Header />

      {/* Page Banner */}
      <section className="breadcrumb breadcrumb-list mb-0">
        <span className="primary-right-round"></span>
        <div className="container">
          <h1 className="text-white">Blog Details</h1>
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb">
              <li className="breadcrumb-item">
                <Link to="/">Home</Link>
              </li>
              <li className="breadcrumb-item active" aria-current="page">
                Blog Details
              </li>
            </ol>
          </nav>
        </div>
      </section>
      <div className="container my-5">
        <div className="blogcard container px-3 px-md-4">
          {blog.featured_image && (
            <img
              src={`https://admin.bookvenue.app/${blog.featured_image}`}
              className="img-fluid mb-4 rounded blog-image-hover"
              alt={blog.title}
            />
          )}

          <div className="d-flex align-items-center mb-3 text-muted small flex-wrap">
            <i
              className="bi bi-person-circle me-2"
              style={{ fontSize: "1.4rem" }}
            ></i>
            <span className="me-2">Written by Admin</span>
            <span className="me-2">|</span>
            <span>{new Date(blog.created_at).toLocaleDateString()}</span>
          </div>

          <hr />

          <div className="title" style={{ color: "#000" }}>
            <h2 className="mb-3">{blog.title}</h2>
          </div>

          <div
            className="blog-description"
            dangerouslySetInnerHTML={{ __html: blog.description }}
          />
        </div>
      </div>

      <Footer />
    </>
  );
};

export default BlogDetails;
